import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'

function inventoryAddonGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  if (store.getters['subscription/isInventoryPurchased']) {
    return next()
  }

  return next({ name: 'error-404' })
}

export default inventoryAddonGuard
